import { useEffect, useMemo, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getSubCollection } from "../utils/getSubCollection";
import { onSnapshot } from "firebase/firestore";

export default function useCategoryOptions(currentValue = "", collection = "categorias") {
  const { user, teamOwnerId } = useAuth();
  const ownerUid = teamOwnerId || user?.uid;
  const [opts, setOpts] = useState([]);

  useEffect(() => {
    if (!ownerUid) return;
    const ref = getSubCollection(ownerUid, collection);
    const unsub = onSnapshot(ref, (snap) => {
      const names = snap.docs
        .map((d) => (d.data()?.nombre || "").trim())
        .filter(Boolean);
      const unique = Array.from(new Set(names))
        .sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }));
      setOpts(unique.map((n) => ({ value: n, label: n })));
    });
    return () => unsub();
  }, [ownerUid, collection]);

  // incluye el valor actual si estás editando y no existe en la lista
  return useMemo(() => {
    const cur = (currentValue || "").trim();
    if (!cur) return opts;
    const exists = opts.some((o) => o.value.toLowerCase() === cur.toLowerCase());
    return exists ? opts : [...opts, { value: cur, label: cur }];
  }, [opts, currentValue]);
}
